import { ACTION, TYPE, applyData, sortByReceivedAt } from './defConstants'

// Type definitions
export interface ThreadData {
  id: string
  emailIds: string[]
}

export interface MailboxInfo {
  mailbox: any
  action: number
}

export interface NotiInfo {
  [key: string]: any
}

export interface EmailObjInterface {
  data: {
    id: string
    mailboxIds: { [key: string]: boolean }
    [key: string]: any
  }
  [key: string]: any
}

export interface MailboxObjInterface {
  getId: () => string
  addThread_no_noti: (thread: ThreadObjInterface, runSort: boolean) => void
  removeThread_no_noti: (thread: ThreadObjInterface, runSort: boolean) => void
  sortThread: () => void
  [key: string]: any
}

export interface DataManagerInterface {
  getEmailById: (emailId: string) => EmailObjInterface | null
  getMailboxById: (mailboxId: string) => MailboxObjInterface | null
  removeEvent0Obj: (
    notiInfo: NotiInfo,
    type: number,
    action: number,
    target: { type: number; id: string },
    obj: any,
  ) => void
  addEvent0Obj: (
    notiInfo: NotiInfo,
    type: number,
    action: number,
    target: { type: number; id: string },
    obj: any,
  ) => void
  isExistEvent0Obj: (
    notiInfo: NotiInfo,
    type: number,
    action: number,
    target: { type: number; id: string },
    obj: any,
  ) => boolean
  [key: string]: any
}

export interface ThreadObjInterface {
  isNew: boolean
  dataMgr: DataManagerInterface
  compEmail: any
  titleEmail: any
  data: ThreadData
  applyData: (
    data: Partial<ThreadData>,
    notiInfo?: NotiInfo | null,
    isRemove?: boolean,
    runSort?: boolean,
    mailboxInfos?: MailboxInfo[] | null,
  ) => boolean
  applyRemove: (notiInfo?: NotiInfo | null, mailboxInfos?: MailboxInfo[] | null) => void
  getId: () => string
  emailIdx: (email: EmailObjInterface | { data: { id: string } } | { id: string }) => number
  addEmail: (
    email: EmailObjInterface,
    notiInfo?: NotiInfo | null,
    runSort?: boolean,
    mailboxInfos?: MailboxInfo[] | null,
  ) => void
  removeEmail: (
    email: EmailObjInterface,
    notiInfo?: NotiInfo | null,
    mailboxInfos?: MailboxInfo[] | null,
  ) => EmailObjInterface | null
  sortEmailIds: () => void
}

function ThreadObj(this: ThreadObjInterface, dataMgr: DataManagerInterface, id: string): void {
  const self = this

  self.isNew = true

  self.dataMgr = dataMgr
  self.compEmail = null
  self.titleEmail = null

  self.data = {
    id,
    emailIds: [],
  }

  self.applyData = (
    data: Partial<ThreadData>,
    notiInfo?: NotiInfo | null,
    isRemove: boolean = false,
    runSort: boolean = true,
    mailboxInfos?: MailboxInfo[] | null,
  ): boolean => {
    const targetData = self.data

    const isNew = self.isNew

    let deleteIdList: string[] = []
    let addIdList: string[] = []
    let updateIdList: string[] = []

    if (mailboxInfos == null || mailboxInfos.length === 0) {
      const oldEmailIds = targetData.emailIds || []
      const newEmailIds = data.emailIds

      const oldMailboxIds: string[] = []
      const newMailboxIds: string[] = []
      oldEmailIds.forEach((emailId) => {
        const emailObj = self.dataMgr.getEmailById(emailId)
        if (emailObj != null) {
          Object.keys(emailObj.data.mailboxIds).forEach((key) => {
            if (oldMailboxIds.indexOf(key) < 0) {
              oldMailboxIds.push(key)
            }
          })
        }
      })
      newEmailIds?.forEach((emailId) => {
        const emailObj = self.dataMgr.getEmailById(emailId)
        if (emailObj != null) {
          Object.keys(emailObj.data.mailboxIds).forEach((key) => {
            if (newMailboxIds.indexOf(key) < 0) {
              newMailboxIds.push(key)
            }
          })
        }
      })

      deleteIdList = [...oldMailboxIds]
      addIdList = []
      updateIdList = []

      newMailboxIds.forEach((mailboxId) => {
        if (oldMailboxIds.indexOf(mailboxId) > -1) {
          updateIdList.push(mailboxId)
          const idx = deleteIdList.indexOf(mailboxId)
          if (idx > -1) {
            deleteIdList.splice(idx, 1)
          }
        } else {
          addIdList.push(mailboxId)
        }
      })
    } else {
      mailboxInfos.forEach((mailboxInfo) => {
        const { mailbox, action } = mailboxInfo
        if (action === ACTION.ADD) {
          addIdList.push(mailbox.getId())
        } else if (action === ACTION.DELETE) {
          deleteIdList.push(mailbox.getId())
        } else if (action === ACTION.UPDATE) {
          updateIdList.push(mailbox.getId())
        }
      })
    }

    const isChanged = applyData(data, targetData)

    const mailboxIdMap: { [key: string]: boolean } = {}

    addIdList.forEach((mailboxId) => {
      const mailbox = self.dataMgr.getMailboxById(mailboxId)
      if (mailbox) {
        mailbox.addThread_no_noti(self, false)
        mailboxIdMap[mailboxId] = true
      }
    })
    deleteIdList.forEach((mailboxId) => {
      const mailbox = self.dataMgr.getMailboxById(mailboxId)
      if (mailbox) {
        mailbox.removeThread_no_noti(self, false)
      }
    })
    updateIdList.forEach((mailboxId) => {
      const mailbox = self.dataMgr.getMailboxById(mailboxId)
      if (mailbox) {
        mailbox.addThread_no_noti(self, false)
        mailboxIdMap[mailboxId] = true
      }
    })

    if (runSort !== false) {
      Object.keys(mailboxIdMap).forEach((mailboxId) => {
        const mailbox = self.dataMgr.getMailboxById(mailboxId)
        if (mailbox) {
          mailbox.sortThread()
        }
      })
    }

    if (notiInfo != null) {
      if (addIdList.length > 0 || deleteIdList.length > 0) {
        addIdList.forEach((mailboxId) => {
          self.dataMgr.removeEvent0Obj(
            notiInfo,
            TYPE.THREAD,
            ACTION.DELETE,
            { type: TYPE.MAILBOX, id: mailboxId },
            self,
          )
          if (
            self.dataMgr.isExistEvent0Obj(
              notiInfo,
              TYPE.THREAD,
              ACTION.UPDATE,
              { type: TYPE.MAILBOX, id: mailboxId },
              self,
            ) === false
          ) {
            self.dataMgr.addEvent0Obj(
              notiInfo,
              TYPE.THREAD,
              ACTION.ADD,
              { type: TYPE.MAILBOX, id: mailboxId },
              self,
            )
          }
        })
        deleteIdList.forEach((mailboxId) => {
          self.dataMgr.removeEvent0Obj(
            notiInfo,
            TYPE.THREAD,
            ACTION.ADD,
            { type: TYPE.MAILBOX, id: mailboxId },
            self,
          )
          self.dataMgr.removeEvent0Obj(
            notiInfo,
            TYPE.THREAD,
            ACTION.UPDATE,
            { type: TYPE.MAILBOX, id: mailboxId },
            self,
          )
          self.dataMgr.addEvent0Obj(
            notiInfo,
            TYPE.THREAD,
            ACTION.DELETE,
            { type: TYPE.MAILBOX, id: mailboxId },
            self,
          )
        })
        updateIdList.forEach((mailboxId) => {
          self.dataMgr.removeEvent0Obj(
            notiInfo,
            TYPE.THREAD,
            ACTION.DELETE,
            { type: TYPE.MAILBOX, id: mailboxId },
            self,
          )
          if (
            self.dataMgr.isExistEvent0Obj(
              notiInfo,
              TYPE.THREAD,
              ACTION.ADD,
              { type: TYPE.MAILBOX, id: mailboxId },
              self,
            ) === false
          ) {
            self.dataMgr.addEvent0Obj(
              notiInfo,
              TYPE.THREAD,
              ACTION.UPDATE,
              { type: TYPE.MAILBOX, id: mailboxId },
              self,
            )
          }
        })
        updateIdList.length = 0
      }

      if (isRemove !== true) {
        if (isChanged === true) {
          updateIdList.forEach((mailboxId) => {
            self.dataMgr.removeEvent0Obj(
              notiInfo,
              TYPE.THREAD,
              ACTION.DELETE,
              { type: TYPE.MAILBOX, id: mailboxId },
              self,
            )
            if (
              self.dataMgr.isExistEvent0Obj(
                notiInfo,
                TYPE.THREAD,
                ACTION.ADD,
                { type: TYPE.MAILBOX, id: mailboxId },
                self,
              ) === false
            ) {
              self.dataMgr.addEvent0Obj(
                notiInfo,
                TYPE.THREAD,
                ACTION.UPDATE,
                { type: TYPE.MAILBOX, id: mailboxId },
                self,
              )
            }
          })

          self.dataMgr.removeEvent0Obj(
            notiInfo,
            TYPE.THREAD,
            ACTION.DESTROY,
            { type: TYPE.DATAMANAGER, id: 'all' },
            self,
          )
          if (isNew === true) {
            if (
              self.dataMgr.isExistEvent0Obj(
                notiInfo,
                TYPE.THREAD,
                ACTION.UPDATE,
                { type: TYPE.DATAMANAGER, id: 'all' },
                self,
              ) === false
            ) {
              self.dataMgr.addEvent0Obj(
                notiInfo,
                TYPE.THREAD,
                ACTION.CREATE,
                { type: TYPE.DATAMANAGER, id: 'all' },
                self,
              )
            }
          } else {
            if (
              self.dataMgr.isExistEvent0Obj(
                notiInfo,
                TYPE.THREAD,
                ACTION.CREATE,
                { type: TYPE.DATAMANAGER, id: 'all' },
                self,
              ) === false
            ) {
              self.dataMgr.addEvent0Obj(
                notiInfo,
                TYPE.THREAD,
                ACTION.MODIFY,
                { type: TYPE.DATAMANAGER, id: 'all' },
                self,
              )
            }
          }
        }
      } else {
        self.dataMgr.removeEvent0Obj(
          notiInfo,
          TYPE.THREAD,
          ACTION.CREATE,
          { type: TYPE.DATAMANAGER, id: 'all' },
          self,
        )
        self.dataMgr.removeEvent0Obj(
          notiInfo,
          TYPE.THREAD,
          ACTION.MODIFY,
          { type: TYPE.DATAMANAGER, id: 'all' },
          self,
        )
        self.dataMgr.addEvent0Obj(
          notiInfo,
          TYPE.THREAD,
          ACTION.DESTROY,
          { type: TYPE.DATAMANAGER, id: 'all' },
          self,
        )
      }
    }

    self.isNew = false

    return isChanged
  }

  self.applyRemove = (notiInfo?: NotiInfo | null, mailboxInfos?: MailboxInfo[] | null): void => {
    const { id } = self.data
    self.applyData(
      {
        id,
        emailIds: [],
      },
      notiInfo,
      true,
      false,
      mailboxInfos,
    )
  }

  self.getId = (): string => {
    return self.data.id
  }

  self.emailIdx = (
    email: EmailObjInterface | { data: { id: string } } | { id: string },
  ): number => {
    const { emailIds } = self.data

    const id = 'data' in email ? email.data.id : 'id' in email ? email.id : ''

    return emailIds.indexOf(id)
  }

  self.addEmail = (
    email: EmailObjInterface,
    notiInfo?: NotiInfo | null,
    runSort: boolean = true,
    mailboxInfos?: MailboxInfo[] | null,
  ): void => {
    const idx = self.emailIdx(email)

    if (idx < 0) {
      const { emailIds } = self.data
      const newEmailIds = [...emailIds]
      newEmailIds.push(email.data.id)

      self.applyData(
        {
          emailIds: newEmailIds,
        },
        notiInfo,
        false,
        runSort,
        mailboxInfos,
      )

      if (runSort !== false) {
        self.sortEmailIds()
      }
    }
  }

  self.removeEmail = (
    email: EmailObjInterface,
    notiInfo?: NotiInfo | null,
    mailboxInfos?: MailboxInfo[] | null,
  ): EmailObjInterface | null => {
    const idx = self.emailIdx(email)

    if (idx > -1) {
      const { emailIds } = self.data
      const newEmailIds = [...emailIds]
      newEmailIds.splice(idx, 1)

      self.applyData(
        {
          emailIds: newEmailIds,
        },
        notiInfo,
        true,
        false,
        mailboxInfos,
      )

      if (newEmailIds.length === 0) {
        self.applyRemove(notiInfo, mailboxInfos)
      }

      return email
    }
    return null
  }

  self.sortEmailIds = (): void => {
    const { emailIds } = self.data
    emailIds.sort((aId, bId) => {
      const a = self.dataMgr.getEmailById(aId)
      const b = self.dataMgr.getEmailById(bId)

      return sortByReceivedAt(a as any, b as any)
    })
  }
}

export default ThreadObj
